export const DownloadBoxIcon = ({
  width = 24,
  height = 24,
  bgColor = "#f5f5f5",
  borderColor = "#6b6a73",
  strokeColor = "#6b6a73",
  borderRadius = 4,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fill-rule="evenodd">
        <path
          d="m10.114 8h-5.114v12h14v-12h-5.114c-.275.583-1.015 1-1.886 1-.871 0-1.612-.417-1.886-1"
          fill-opacity=".1"
          class="dtSf--A2"
        ></path>
        <g
          class="dtSs--A2"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke="#6b6a73"
          background="red"
        >
          <path d="m12 3.5v12"></path>
          <path d="M15.5 12 12 15.5 8.5 12"></path>
          <path d="m9.969 7.5h-4.469v12h13v-12h-4.47"></path>
        </g>
      </g>
    </svg>
  );
};

export const SignatureIcon = ({
  width = 24,
  height = 24,
  stroke = "#6b6a73",
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke={stroke}
      fill-rule="evenodd"
      class="dtSs--A2"
      stroke-linecap="round"
    >
      <g stroke-linejoin="round">
        <path d="m3 11.5l4 4"></path>
        <path d="m7 11.5l-4 4"></path>
      </g>
      <path d="m3 18.5h18"></path>
      <path d="m9 13.583c9.15 1.487 12.828-7.545 9.509-8.49-4.24-1.207-6.04 9.73-2.754 10.03 1.749.161 3.353-2.01 5.246.376"></path>
    </g>
  </svg>
);

export const InitialIcon = ({
  width = 24,
  height = 24,
  stroke = "#6b6a73",
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <g
      fill="none"
      fill-rule="evenodd"
      stroke={stroke}
      class="dtSs--A2"
      stroke-linecap="round"
    >
      <g stroke-linejoin="round" stroke={stroke}>
        <path d="m3 11.924l2.743 2.554"></path>
        <path d="m5.743 11.924l-2.743 2.554"></path>
        <path d="m15.5 6.5v8"></path>
        <path d="m15.58 10.5h2.34c1.093 0 1.98-.895 1.98-2 0-1.104-.887-2-1.98-2h-3.42"></path>
        <path d="m17.853 10.5h.529c1.169 0 2.118.896 2.118 2 0 1.104-.949 2-2.118 2h-3.882"></path>
        <path d="m14 14.5l-3-8-3 8"></path>
        <path d="m9.5 11.5h3"></path>
        <path d="m7.5 14.5h1.5"></path>
        <path d="m13 14.5h1.5"></path>
      </g>
      <path d="m3 17.5h18"></path>
    </g>
  </svg>
);

export const TextBoxIcon = ({
  width = 24,
  height = 24,
  stroke = "#6b6a73",
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke={stroke}
      fill-rule="evenodd"
      class="dtSs--A2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m5 5h14v14h-14z"></path>
      <path d="m8 9h8"></path>
      <path d="m8 12h8"></path>
      <path d="m8 15h5"></path>
    </g>
  </svg>
);

export const DragIcon = ({ width = 10, height = 10, fill = "white" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill={fill}>
    <path d="M7 2h2v2H7V2zm0 6h2v2H7V8zm0 6h2v2H7v-2zm6-12h2v2h-2V2zm0 6h2v2h-2V8zm0 6h2v2h-2v-2zm6-12h2v2h-2V2zm0 6h2v2h-2V8zm0 6h2v2h-2v-2z" />
  </svg>
);

export const CheckBoxIcon = ({
  width = 24,
  height = 24,
  stroke = "#6b6a73",
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd" stroke={stroke}>
      <path
        fill-opacity=".1"
        class="dtSf--A"
        d="m5 6.5h1.5v-1.5h11v1.5h1.5v11h-1.5v1.5h-11v-1.5h-1.5z"
      ></path>

      <g class="dtSs--A2" stroke-linejoin="round" stroke={stroke}>
        <path d="m19 6.5v11"></path>
        <path d="m6.5 5h11"></path>
        <path d="m5 17.5v-11"></path>
        <path d="m17.5 19h-11"></path>
        <g stroke-linecap="round" stroke={stroke}>
          <path d="m3.5 6.5h3v-3h-3z"></path>
          <path d="m17.5 6.5h3v-3h-3z"></path>
          <path d="m3.5 20.5h3v-3h-3z"></path>
          <path d="m17.5 20.5h3v-3h-3z"></path>
          <path d="m8 10v-2h8v2"></path>
          <path d="m12 8v8.5"></path>
          <path d="m11 16.5h2"></path>
        </g>
      </g>
    </g>
  </svg>
);

export const DateIcon = ({ width = 24, height = 24, stroke = "#6b6a73" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <g stroke={stroke} fill="none" fill-rule="evenodd">
      <path
        d="m3 9h18v11h-18v-11m4-5h2v2h-2v-2m8 0h2v2h-2v-2"
        fill-opacity=".1"
        class="dtSf--A"
      ></path>
      <g
        stroke={stroke}
        class="dtSs--A2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m6.457 5h-2.957v15.5h17v-15.5h-2.957"></path>
        <path d="m6.5 6.5h2.5v-3h-2.5z"></path>
        <path d="m15 6.5h2.5v-3h-2.5z"></path>
        <path d="m9 5h5.5"></path>
        <path d="m3.5 8.5h17"></path>
      </g>
      <path
        d="m6 19c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m-2-8c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m-12 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m-12 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m-12 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5m2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5"
        class="dtSf--A"
      ></path>
    </g>
  </svg>
);

// export const CheckBoxIcon = ({
//   width = 24,
//   height = 24,
//   stroke = "#6b6a73",
//   bgColor = "#d6dbe9",
// }) => (
//   <svg width={width} height={height} viewBox="0 0 24 24">
//     <g
//       fill="none"
//       fill-rule="evenodd"
//       class="dtSs--A2"
//       stroke-linecap="round"
//       stroke-linejoin="round"
//       stroke={stroke}
//     >
//       <rect
//         x="3.5"
//         y="3.5"
//         width="17"
//         height="17"
//         rx="2.957" // matches path's corner radius
//         fill={bgColor}
//       />
//       <path
//         fill-opacity=".1"
//         class="dtSf--A"
//         d="m20.5 17.543c0 1.626-1.33 2.957-2.957 2.957h-11.09c-1.626 0-2.957-1.33-2.957-2.957v-11.09c0-1.626 1.33-2.957 2.957-2.957h11.09c1.626 0 2.957 1.33 2.957 2.957v11.09"
//       ></path>
//     </g>
//   </svg>
// );
